export const GatewayTypes = {
    NEXTPAY: {
        id: "NEXTPAY",
        name: "نکس پی"
    },
    ZARINPAL: {
        id: "ZARINPAL",
        name: "زرین پال"
    },
    PERSIAN_BANK: {
        id: "PERSIAN_BANK",
        name: "پارسیان"
    }
}